var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { TswagClient } from "./../commons/TswagClient";
import { Error as ApiError } from "./../models/V1/Primitives/Error/Error";
import { PossibleStatusChange } from "./../models/V1/Companies/IossRegistrations/PossibleStatusChange";
import { SearchResult } from "./../models/V1/Companies/IossRegistrations/Search/SearchResult";
export class CompaniesIossRegistrations {
  /**
   * Creates an instance of CompaniesIossRegistrations.
   * @param {string} [baseUrl]
   * @param {{ fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }} [http]
   * @memberof CompaniesIossRegistrations
   */
  constructor(baseUrl, http) {
    __publicField(this, "http");
    __publicField(this, "baseUrl");
    this.baseUrl = baseUrl;
    this.http = http ? http : window;
  }
  /**
   * @param ChangeStartDateRq_ _changeStartDateRq
   * @returns Promise<ChangeStartDateRq_>
   * @memberof CompaniesIossRegistrations
   */
  changeStartDate(pChangeStartDateRq, options = {}) {
    const client = new TswagClient(
      this.baseUrl + "/api/v1/companies/{companyId}/iossregistrations/{registrationId}/startDate",
      "PUT",
      "application/json; charset=UTF-8",
      "text/plain, application/json, text/json",
      options
    );
    client.addPathParams([
      { name: "companyId", value: pChangeStartDateRq.companyId, required: true },
      { name: "registrationId", value: pChangeStartDateRq.registrationId, required: true }
    ]);
    client.addBody({ value: pChangeStartDateRq.body });
    const respDescriptor = {
      headerParams: [],
      items: [{ statusCode: 204 }, { statusCode: 400, clazz: ApiError }, { statusCode: 403, clazz: ApiError }, { statusCode: 404, clazz: ApiError }]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param ChangeStatusRq_ _changeStatusRq
   * @returns Promise<ChangeStatusRq_>
   * @memberof CompaniesIossRegistrations
   */
  changeStatus(pChangeStatusRq, options = {}) {
    const client = new TswagClient(
      this.baseUrl + "/api/v1/companies/{companyId}/iossregistrations/{registrationId}/status",
      "PUT",
      "application/json; charset=UTF-8",
      "text/plain, application/json, text/json",
      options
    );
    client.addPathParams([
      { name: "companyId", value: pChangeStatusRq.companyId, required: true },
      { name: "registrationId", value: pChangeStatusRq.registrationId, required: true }
    ]);
    client.addBody({ value: pChangeStatusRq.body });
    const respDescriptor = {
      headerParams: [],
      items: [{ statusCode: 204 }, { statusCode: 404, clazz: ApiError }, { statusCode: 409, clazz: ApiError }, { statusCode: 422, clazz: ApiError }]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param DownloadCertificateRq_ _downloadCertificateRq
   * @returns Promise<DownloadCertificateRq_>
   * @memberof CompaniesIossRegistrations
   */
  downloadCertificate(pDownloadCertificateRq, options = {}) {
    const client = new TswagClient(
      this.baseUrl + "/api/v1/companies/{companyId}/iossregistrations/{registrationId}/certificate",
      "GET",
      "application/json; charset=UTF-8",
      "application/pdf, application/json",
      options
    );
    client.addPathParams([
      { name: "companyId", value: pDownloadCertificateRq.companyId, required: true },
      { name: "registrationId", value: pDownloadCertificateRq.registrationId, required: true }
    ]);
    const respDescriptor = {
      headerParams: [],
      items: [
        { statusCode: 200, isFile: true },
        { statusCode: 404, clazz: ApiError }
      ]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param DownloadDeregistrationDocumentRq_ _downloadDeregistrationDocumentRq
   * @returns Promise<DownloadDeregistrationDocumentRq_>
   * @memberof CompaniesIossRegistrations
   */
  downloadDeregistrationDocument(pDownloadDeregistrationDocumentRq, options = {}) {
    const client = new TswagClient(
      this.baseUrl + "/api/v1/companies/{companyId}/iossregistrations/{registrationId}/deregistrationdocument",
      "GET",
      "application/json; charset=UTF-8",
      "application/pdf, application/json",
      options
    );
    client.addPathParams([
      { name: "companyId", value: pDownloadDeregistrationDocumentRq.companyId, required: true },
      { name: "registrationId", value: pDownloadDeregistrationDocumentRq.registrationId, required: true }
    ]);
    const respDescriptor = {
      headerParams: [],
      items: [
        { statusCode: 200, isFile: true },
        { statusCode: 404, clazz: ApiError }
      ]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param DownloadRegistrationDocumentRq_ _downloadRegistrationDocumentRq
   * @returns Promise<DownloadRegistrationDocumentRq_>
   * @memberof CompaniesIossRegistrations
   */
  downloadRegistrationDocument(pDownloadRegistrationDocumentRq, options = {}) {
    const client = new TswagClient(
      this.baseUrl + "/api/v1/companies/{companyId}/iossregistrations/{registrationId}/documents/{documentId}",
      "GET",
      "application/json; charset=UTF-8",
      "application/pdf, application/json",
      options
    );
    client.addQueryParams([{ name: "type", value: pDownloadRegistrationDocumentRq.type, required: true }]);
    client.addPathParams([
      { name: "companyId", value: pDownloadRegistrationDocumentRq.companyId, required: true },
      { name: "registrationId", value: pDownloadRegistrationDocumentRq.registrationId, required: true },
      { name: "documentId", value: pDownloadRegistrationDocumentRq.documentId, required: true }
    ]);
    const respDescriptor = {
      headerParams: [],
      items: [
        { statusCode: 200, isFile: true },
        { statusCode: 404, clazz: ApiError }
      ]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param ExportRq_ _exportRq
   * @returns Promise<ExportRq_>
   * @memberof CompaniesIossRegistrations
   */
  export(pExportRq, options = {}) {
    const client = new TswagClient(this.baseUrl + "/api/v1/companies/iossregistrations/export", "POST", "application/json; charset=UTF-8", "text/csv, application/json", options);
    client.addBody({ value: pExportRq.body });
    const respDescriptor = {
      headerParams: [],
      items: [
        { statusCode: 200, isFile: true },
        { statusCode: 400, clazz: ApiError }
      ]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param GetAvailableStatusChangesRq_ _getAvailableStatusChangesRq
   * @returns Promise<GetAvailableStatusChangesRq_>
   * @memberof CompaniesIossRegistrations
   */
  getAvailableStatusChanges(options = {}) {
    const client = new TswagClient(this.baseUrl + "/api/v1/companies/iossregistrations/statuses", "GET", "application/json; charset=UTF-8", "text/plain, application/json, text/json", options);
    const respDescriptor = {
      headerParams: [],
      items: [{ statusCode: 200, clazz: PossibleStatusChange, isArray: true }]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param SearchRq_ _searchRq
   * @returns Promise<SearchRq_>
   * @memberof CompaniesIossRegistrations
   */
  search(pSearchRq, options = {}) {
    const client = new TswagClient(this.baseUrl + "/api/v1/companies/iossregistrations/search", "POST", "application/json; charset=UTF-8", "text/plain, application/json, text/json", options);
    client.addBody({ value: pSearchRq.body });
    const respDescriptor = {
      headerParams: [],
      items: [
        { statusCode: 200, clazz: SearchResult },
        { statusCode: 400, clazz: ApiError }
      ]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param UploadDocumentRq_ _uploadDocumentRq
   * @returns Promise<UploadDocumentRq_>
   * @memberof CompaniesIossRegistrations
   */
  uploadDocument(pUploadDocumentRq, options = {}) {
    const client = new TswagClient(
      this.baseUrl + "/api/v1/companies/{companyId}/iossregistrations/{registrationId}/document",
      "POST",
      "multipart/form-data",
      "text/plain, application/json, text/json",
      options
    );
    client.addPathParams([
      { name: "companyId", value: pUploadDocumentRq.companyId, required: true },
      { name: "registrationId", value: pUploadDocumentRq.registrationId, required: true }
    ]);
    client.addFormData("multipart/form-data", [{ name: "file", value: pUploadDocumentRq.file }]);
    const respDescriptor = {
      headerParams: [],
      items: [{ statusCode: 200 }, { statusCode: 404, clazz: ApiError }]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param UploadSignedRegistrationDocumentRq_ _uploadSignedRegistrationDocumentRq
   * @returns Promise<UploadSignedRegistrationDocumentRq_>
   * @memberof CompaniesIossRegistrations
   */
  uploadSignedRegistrationDocument(pUploadSignedRegistrationDocumentRq, options = {}) {
    const client = new TswagClient(
      this.baseUrl + "/api/v1/companies/{companyId}/iossregistrations/{registrationId}/documents/{documentId}/signed",
      "POST",
      "multipart/form-data",
      "text/plain, application/json, text/json",
      options
    );
    client.addPathParams([
      { name: "companyId", value: pUploadSignedRegistrationDocumentRq.companyId, required: true },
      { name: "registrationId", value: pUploadSignedRegistrationDocumentRq.registrationId, required: true },
      { name: "documentId", value: pUploadSignedRegistrationDocumentRq.documentId, required: true }
    ]);
    client.addFormData("multipart/form-data", [{ name: "file", value: pUploadSignedRegistrationDocumentRq.file }]);
    const respDescriptor = {
      headerParams: [],
      items: [{ statusCode: 200 }, { statusCode: 404, clazz: ApiError }]
    };
    return client.fetch(this.http, respDescriptor);
  }
}
export var DownloadRegistrationDocumentType = /* @__PURE__ */ ((DownloadRegistrationDocumentType2) => {
  DownloadRegistrationDocumentType2["Unsigned"] = "Unsigned";
  DownloadRegistrationDocumentType2["Signed"] = "Signed";
  return DownloadRegistrationDocumentType2;
})(DownloadRegistrationDocumentType || {});
